const SOCIAL_PROVIDERS = {
    GOOGLE: 'google',
};

export default SOCIAL_PROVIDERS;
